import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import parse from 'url-parse';
import get from 'lodash/get';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line react/prefer-stateless-function
class SitemapPost extends Component {
  render() {
    if (
      this.props.htmlSitemapPostPage &&
      this.props.htmlSitemapPostPage.error
    ) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.htmlSitemapPostPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const startDate = get(this.props, 'htmlSitemapPost.startDate');
    const endDate =
      get(this.props, 'htmlSitemapPost.endDate') ||
      get(this.props, 'htmlSitemapPost.amp;endDate');
    const siteMapYear = endDate && endDate.length ? endDate.slice(0, 4) : '';
    const siteMapYearPath = `/sitemap/year/${siteMapYear}`;

    if (!startDate || !endDate) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    return (
      <section className="html-sitemap-index-page">
        <div className="html-sitemap-index-page__main">
          <h2 className="html-sitemap-index-page__heading">
            <Link to="/sitemap">Site Map</Link> &gt;{' '}
            <Link to={siteMapYearPath}>{siteMapYear}</Link> &gt;{' '}
            {get(this.props, 'htmlSitemapPost.title')}
          </h2>
          {this.props.htmlSitemapPost.posts.map(function sitemapLink(post) {
            return (
              <Link
                to={post.url.replace(parse(post.url).origin, '')}
                className="url--week"
                key={post.url}
              >
                {post.title}
              </Link>
            );
          })}
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    htmlSitemapPostPage: state.htmlSitemapPostPage || {},
    htmlSitemapPost: get(state, 'htmlSitemapPost.data') || { error: true }
  };
}

SitemapPost.propTypes = {
  htmlSitemapPostPage: PropTypes.shape({
    // eslint-disable-next-line
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  htmlSitemapPost: PropTypes.shape({
    // eslint-disable-next-line
    error: PropTypes.bool,
    title: PropTypes.string,
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps)(SitemapPost);



// WEBPACK FOOTER //
// ./src/views/containers/pages/html_sitemap_post_page/html_sitemap_post_page.js